import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TouchSequence } from 'selenium-webdriver';
import { Preferences } from '@capacitor/preferences';
import { DataService } from '../services/data.service';
@Injectable({
  providedIn: 'root'
})
export class AuthguardGuard implements CanActivate {
  constructor(
    private dataSRV:DataService,
    private router:Router){

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.dataSRV.isAuthenticated.pipe(map(
        isAuthenticated=>{
          if(isAuthenticated){
            return true
          } else {
            return this.router.parseUrl('/login')
          }
        }
      ))
      
    }
  
}
